package cc.bluepeak.clubmanager.site

import cc.bluepeak.clubmanager.enums.Locale
import libres.resources.strings.StringsEn

internal object Res {
    val string = StringsEn

    val locales = listOf(Locale.English, Locale.German)

    object image {
        const val logo = "/images/logo.svg"
        const val hero = "/images/hero.webp"
        const val fabric1 = "/images/fabric1.webp"
        const val fabric2 = "/images/fabric2.webp"
        const val fabric3 = "/images/fabric3.webp"
        const val fabric4 = "/images/fabric4.webp"
        const val apple = "/images/apple.svg"
        const val android = "/images/android.svg"
        const val windows = "/images/windows.svg"
        const val squad = "/images/squad.webp"
        const val calendar = "/images/calendar.webp"
        const val club = "/images/club.webp"
        const val finance = "/images/finance.webp"
        const val excel_to_cm = "/images/excel_to_cm.webp"
        const val team_resting = "/images/team_resting.webp"
        const val team_training = "/images/team_training.webp"
        const val team_celebrating = "/images/team_celebrating.webp"
        const val member_connected_icon = "/images/member_connected.webp"
        const val members_connected_icon = "/images/members_connected.webp"
        const val calendar_icon = "/images/calendar_icon.webp"
        const val notes_icon = "/images/notes_icon.webp"
        const val demoInvoice = "/images/demo_invoice.webp"
        const val coins_icon = "/images/coins.webp"
        const val invoice_icon = "/images/invoice_icon.webp"
    }

    object link {
        const val home = "/"
        const val features = "/#features"
        const val pricing = "/pricing"
        const val downloads = "/downloads"
        const val contact = "/contact"
        const val register = "/register"
        const val helpdesk = "/help"
        const val memberAdministration = "/member-administration"
        const val squadManagement = "/squad-management"
        const val calendar = "/calendar"
        const val invoicing = "/invoicing"
        const val macos = "https://apps.apple.com/us/app/clubmanager-pro/id6747259241"
        const val windows = "https://apps.microsoft.com/detail/9nxgc7kh8nlk"
        const val android = "https://play.google.com/store/apps/details?id=cc.bluepeak.clubmanager"
        const val ios = "https://apps.apple.com/us/app/clubmanager-pro/id6747259241"
        const val web = "https://app.clubmanager.cc"
        const val supportForm = "https://bluepeak.youtrack.cloud/form/a65cbb32-94f2-4d10-96a5-ba12abb4316b"
        fun preview(id: String) = "https://preview.clubmanager.cc/#$id"
    }
}